"use client";

import { TFaqSection } from "@shared/types";
import { Accordion, SectionHeading } from "@shared/ui";

export function FaqSection({ title, description, accordions }: TFaqSection) {
  return (
    <section className="py-[80px] sm:py-[100px] lg:py-[120px] relative overflow-hidden bg-white">
      <div className="container relative">
        <div className="flex gap-10 xl:gap-[100px] w-full flex-col lg:flex-row">
          <div className="lg:w-[45%] lg:min-w-[45%]">
            <SectionHeading
              title={title}
              titleClassName={"w-full mx-0 text-5xl sm:text-6xl leading-[115%]"}
              description={description}
              descriptionClassName="text-xl sm:text-2xl leading-[132%]"
            />
          </div>
          <div className="flex-1">
            {accordions && accordions.data && accordions.data.length > 0 && <Accordion accordions={accordions.data} />}
          </div>
        </div>
      </div>
    </section>
  );
}
